import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const UserTypeUpdatePage = lazy(() => import('../views/update/UserTypeUpdatePage'));

export function UserTypeUpdatePageLazy() {
	return (
		<PageSuspense>
			<UserTypeUpdatePage />
		</PageSuspense>
	);
}
